
import './PTrackContainer.scss';
export default function PTrackContainer(props: any) {
    return (
        <div className="ptrack-container ">{props.children}</div>
    );
}